/* global window document HTMLElement */

export default class CookieBannerTriggerButton {

    constructor(buttonElement) {
        if (!(buttonElement instanceof HTMLElement)) {
            throw new Error(`Expected the argument buttonElement to be an HTMLElement. Got ${buttonElement} instead.`);
        }

        this.buttonElement = buttonElement;
    }

    setup() {
        this.registerButtonClickListener();
    }

    registerButtonClickListener() {
        this.buttonElement.addEventListener('click', this.handleButtonClick.bind(this));
    }

    handleButtonClick(event) {
        event.preventDefault();
        if (!window.Drupal || !window.Drupal.eu_cookie_compliance) {
            console.warn('CookieBannerTriggerButton: window.Drupal.eu_cookie_compliance is not available.');
            return;
        }
        if (!window.drupalSettings || !window.drupalSettings.eu_cookie_compliance) {
            console.warn('CookieBannerTriggerButton: window.drupalSettings.eu_cookie_compliance is not available.');
        }

        // make sure we don't show the cookie banner if it's already there
        // if we did buttons wouldn't work anymore
        if (document.querySelector('#sliding-popup')) return;

        window.Drupal.eu_cookie_compliance
            .createPopup(window.drupalSettings.eu_cookie_compliance.popup_html_info, false);
        window.Drupal.eu_cookie_compliance.initPopup();
    }
}
